// extracted by mini-css-extract-plugin
export default {"root":"add-range-button_root__Netf2","wrap":"add-range-button_wrap__qUK1b"};